import type { ActivityPair } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import { BolusActivityMessage } from "./BolusActivityMessage"
import { CGMSessionEndedMessage } from "./CGMSessionEndedMessage"
import { ExerciseActivityMessage } from "./ExerciseActivityMessage"
import { PumpSuspensionActivityMessage } from "./PumpSuspensionActivityMessage"
import type {
  ReadOnlySubEntry,
  ReadOnlyUserEvent,
} from "src/types"

export type Props = ComponentPropsWithoutRef<"div"> &
  ActivityPair & {
    item: ReadOnlySubEntry | ReadOnlyUserEvent;
  }

export const ActivityMessage = forwardRef<HTMLDivElement, Props>(
  function ActivityMessage(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity, activityType, item, ...htmlDivProps
    } = props

    if (activityType === ActivityType.Exercise) {
      return (
        <ExerciseActivityMessage
          {...htmlDivProps}
          item={item}
          activity={activity}
        />
      )
    }

    if (activityType === ActivityType.Bolus) {
      return (
        <BolusActivityMessage
          {...htmlDivProps}
          ref={ref}
          activity={activity}
        />
      )
    }

    if (activityType === ActivityType.CGMSessionEnded) {
      return (
        <CGMSessionEndedMessage
          {...htmlDivProps}
          ref={ref}
          activity={activity}
        />
      )
    }

    if (activityType === ActivityType.PumpSuspension) {
      return (
        <PumpSuspensionActivityMessage
          {...htmlDivProps}
          ref={ref}
          item={item}
          activity={activity}
        />
      )
    }

    if (activityType === ActivityType.Note) {
      return null
    }

    if (!item.note) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {item.note}
      </div>
    )
  },
)
